import type { SessionProfile } from '../../types/session';

export type AccessLevel = 'user' | 'staff' | 'admin';
export type AccessView = 'staff' | 'user' | null;

export const ACCESS_VIEW_STORAGE_KEY = 'rs-access-view';

export function actualAccessLevel(profile: SessionProfile): AccessLevel {
  if (profile.isAdmin) return 'admin';
  if (profile.isStaff) return 'staff';
  return 'user';
}

export function allowedAccessView(profile: SessionProfile, requested: AccessView): AccessView {
  const actual = actualAccessLevel(profile);
  if (requested === 'user' && actual !== 'user') return requested;
  if (requested === 'staff' && actual === 'admin') return requested;
  return null;
}

/**
 * Esta vista previa nunca tocó más que `roles`/`isAdmin`/`isStaff`/`bond` —
 * `permissions` queda tal cual llegó del servidor. Es una limitación
 * conocida, no nueva: alguien con `sysadmin` además de `admin` seguiría
 * viendo la sección de Sistema al "verse como" Vigía. No es un problema de
 * autorización real (el servidor sigue rechazando cada acción por su
 * cuenta) — es solo una vista previa imprecisa en ese caso puntual.
 */
export function profileForAccessView(profile: SessionProfile, requested: AccessView): SessionProfile {
  const view = allowedAccessView(profile, requested);
  if (!view) return profile;
  if (view === 'staff') {
    return { ...profile, roles: profile.roles.filter((role) => role !== 'admin'), isAdmin: false, isStaff: true, bond: 'staff' };
  }
  return {
    ...profile,
    roles: profile.roles.filter((role) => !['admin', 'staff'].includes(role)),
    isAdmin: false,
    isStaff: false,
    bond: 'member',
  };
}

export function storedAccessView(profile: SessionProfile): AccessView {
  try {
    const stored = localStorage.getItem(ACCESS_VIEW_STORAGE_KEY);
    return allowedAccessView(profile, stored === 'staff' || stored === 'user' ? stored : null);
  } catch {
    return null;
  }
}
